<template>
    <v-container>
        <!--    Diálogo  Modal para mostrar mensaje Servicio Suspendido    -->
        <v-dialog v-model="dialogNopay" max-width="500">
            <v-card>
                <v-toolbar dark color="warning">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogNopay = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline">
                    {{$t('servicio_suspendido')}}
                </v-card-title>
                <v-card-text align="left">
                    <p>
                        {{$t('msg_supendido')}}<br> <br>
                        <ul>
                            <li>{{$t('msg_supendido1')}}</li>
                            <li>{{$t('msg_supendido2')}}</li>
                        </ul><br>
                        {{$t('msg_supendido3')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="black" outlined @click="dialogNopay = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageFront"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingFront()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageBack"
                            :src="imageBackURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Dialog para Mostrar mensaje "Seleccionar al menos un día de la Semana"       -->
        <v-dialog
                v-model="dialogAtLeastOneDay"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    {{$t('msg_no_days')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogAtLeastOneDay = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal para Registrar Invitado       -->
        <v-dialog v-model="dialogGuest" persistent scrollable max-width="600px">
            <v-form @submit.prevent="createGuest()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{ $t('invitado') }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="cleanFieldsGuest(), bandGuest = false, dialogGuest = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field
                                v-model="first_name"
                                autofocus
                                prepend-icon="mdi-account"
                                name="first_name"
                                :label="$t('Nombre')"
                                :error-messages="errores.first_name"
                        >
                        </v-text-field>
                        <v-text-field
                                v-model="last_name"
                                prepend-icon="mdi-account-outline"
                                name="last_name"
                                :label="$t('Apellido')"
                                :error-messages="errores.last_name"
                        >
                        </v-text-field>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                <v-label>
                                    {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                </v-label>
                                <br>
                                <v-img
                                        class="pt-3 pb-3"
                                        :src="resultFrontURL"
                                        v-if="resultFrontURL"
                                        width="auto"
                                        height="180"
                                ></v-img>
                                <br>
                                <v-btn dark
                                        color="primary">
                                    <clipper-upload
                                            @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                                            accept="image/*"
                                            v-model="imageFrontURL"
                                    >
                                        {{$t('subir_imagen')}}
                                    </clipper-upload>
                                </v-btn>
                                <br>
                                <v-alert
                                        v-if="errores.idFront"
                                        type="error"
                                        outlined
                                        transition="scale-transition"
                                >
                                    {{errores.idFront}}
                                </v-alert>
                            </v-flex>
                            <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                <v-label>
                                    {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                </v-label>
                                <br>
                                <v-img
                                        class="pt-3 pb-3"
                                        :src="resultBackURL"
                                        v-if="resultBackURL"
                                        width="auto"
                                        height="180"
                                ></v-img>
                                <br>
                                <v-btn dark
                                        color="primary">
                                    <clipper-upload
                                            @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                                            accept="image/*"
                                            v-model="imageBackURL"
                                    >
                                        {{$t('subir_imagen')}}
                                    </clipper-upload>
                                </v-btn>
                                <br>
                                <v-alert
                                        v-if="errores.idBack"
                                        type="error"
                                        outlined
                                        transition="scale-transition"
                                >
                                    {{errores.idBack}}
                                </v-alert>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                <div class="splash-info">
                                    <v-label>
                                        {{$t('foto_perfil')}}
                                    </v-label>
                                    <br>
                                    <div class="wrapper">
                                        <img
                                                :src="resultProfileURL"
                                                v-if="resultProfileURL">
                                    </div>
                                    <br>
                                    <v-btn dark
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageProfileURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                            v-if="errores.avatar"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.avatar}}
                                    </v-alert>
                                </div>
                            </v-flex>
                        </v-layout>
                        <br>
                        {{$t('celular')}}
                        <vue-tel-input
                                class="mt-3 mb-3"
                                v-model="celular"
                                @onInput="onInput"
                        >
                            <v-alert v-if="errores.cellNumber" type="error">{{errores.cellNumber}}</v-alert>
                        </vue-tel-input>
                        <v-alert outlined v-if="errores.cellNumber" type="error">{{errores.cellNumber}}</v-alert>
                        <!--                        <v-layout row wrap>-->
                        <!--                            <v-flex v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">-->
                        <!--                                <v-text-field-->
                        <!--                                        v-model="emailGuest"-->
                        <!--                                        prepend-icon="mdi-email"-->
                        <!--                                        name="emailGuest"-->
                        <!--                                        label="E-Mail"-->
                        <!--                                        :error-messages="errores.email"-->
                        <!--                                >-->
                        <!--                                </v-text-field>-->
                        <!--                            </v-flex>-->
                        <!--                            <v-flex v-show="update" v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">-->
                        <!--                                <v-checkbox-->
                        <!--                                        v-model="activa"-->
                        <!--                                        name="activa"-->
                        <!--                                        :label="$t('Activo')"-->
                        <!--                                        :error-messages="errores.activa"-->
                        <!--                                ></v-checkbox>-->
                        <!--                            </v-flex>-->
                        <!--                        </v-layout>-->
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                dark
                                @click="cleanFieldsGuest(),
                                    dialogGuest = false,
                                    bandGuest = false"
                        >{{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                color="primary"
                                dark
                                :loading="loading"
                                type="submit"
                        >{{$t('agregar')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo para Agreragar un Nuevo Contacto    -->
        <v-dialog v-model="dialogNewContact" max-width="500px">
            <v-card>
                <v-form
                    @submit.prevent="validateCellNumber()"
                >
                    <v-card-title>
                        <span class="headline">{{$t('add_new_contact')}}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <div class="flex">
                                <vue-phone-number-input
                                        default-country-code="MX"
                                        color="#D32F2F"
                                        valid-color="#2196F3"
                                        @update="onChange"
                                        v-model="celular_nuevo"
                                        :only-countries="countries"
                                        :translations="custom_cell_phone"
                                >
                                </vue-phone-number-input>
                            </div>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogNewContact = false"
                        >{{$t('cerrar')}}</v-btn>
                        <v-spacer/>
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{$t('agregar')}}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-layout calign-center justify-center fill-height>
            <v-card class="elevation-5" width="1000">
                    <v-toolbar class="mb-0" dark color="primary">
                        <v-toolbar-title>
                            {{$t('Invitacion')}}
                        </v-toolbar-title>
                        <template v-slot:extension>
                            <v-speed-dial
                                    v-model="fab"
                                    top
                                    left
                                    direction="right"
                                    transition="slide-y-reverse-transition"
                            >
                                <template v-slot:activator>
                                    <v-btn
                                            v-model="fab"
                                            color="secondary"
                                            dark
                                            fab
                                    >
                                        <v-icon v-if="fab">mdi-close</v-icon>
                                        <v-icon v-else>mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                                v-on="on"
                                                fab
                                                dark
                                                small
                                                color="purple"
                                                @click="dialogNewContact = true, celular_nuevo = '', band_cellphone = false"
                                        >
                                            <v-icon>mdi-account-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('add_new_contact')}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                                v-on="on"
                                                fab
                                                dark
                                                small
                                                color="primary"
                                                v-if="getProfile.role === 2"
                                                @click="dialogGuest = true, bandGuest = true, cleanFieldsGuest()"
                                        >
                                            <v-icon>mdi-account-check</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('sign_up_new_contact')}}</span>
                                </v-tooltip>
                            </v-speed-dial>
                        </template>
                    </v-toolbar>
                    <v-card-text>
                            <v-form @submit.prevent="createInvitation()">
                                <v-row class="justify-start">
                                    <v-col
                                            cols="6"
                                    >
                                        <v-checkbox
                                                v-model="band_invitacion_recurrente"
                                                name="band_invitacion_recurrente"
                                                :label="$t('lbl_invitacion_recurrente')"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col
                                            cols="6"
                                    >
                                        <v-checkbox
                                                v-model="supplier"
                                                name="supplier"
                                                append-icon="mdi-help-circle"
                                                :label="$t('q_supplier')"
                                                @click:append="show = !show"
                                        ></v-checkbox>
                                    </v-col>
                                        <v-alert
                                            v-show="show"
                                            type="info"
                                            outline
                                            dense
                                            text
                                        >
                                          {{$t('tooltip_supplier')}}
                                        </v-alert>
                                    <v-col cols="12">
                                        <v-autocomplete
                                                v-model="email"
                                                :items="items"
                                                multiple
                                                chips
                                                prepend-icon="mdi-email"
                                                :loading="isLoading"
                                                :search-input.sync="search"
                                                :item-text="example"
                                                item-value="cellNumber"
                                                :placeholder="$t('placeholder_invitados2')"
                                                :label="$t('invitados')"
                                                :error-messages="errors.guests"
                                                :no-data-text="$t('no_resultados')"
                                                autocomplete="off"
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                        v-bind="data.attrs"
                                                        :input-value="data.selected"
                                                        close
                                                        @click="data.select"
                                                        @click:close="remove(data.item)"
                                                >
                                                    <v-avatar left>
                                                        <v-img :src="data.item.avatar"></v-img>
                                                    </v-avatar>
                                                    {{ data.item.first_name }} {{data.item.last_name}}
                                                </v-chip>
                                            </template>
                                            <template v-slot:item="data">
                                                <template v-if="typeof data.item !== 'object'">
                                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                                </template>
                                                <template v-else>
                                                    <v-list-item-avatar>
                                                        <img :src="data.item.avatar">
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-item-title>
                                                        <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </template>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col
                                            v-if="band_invitacion_recurrente"
                                            cols="12"
                                            md="6"
                                    >
                                        <v-label>{{ $t('lbl_selecciona_dias') }}</v-label>
                                        <v-container fluid grid-list-sm>
                                            <v-layout row wrap>
                                                <v-checkbox
                                                        v-model="Monday"
                                                        :label="$t('Lunes')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Tuesday"
                                                        :label="$t('Martes')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Wednesday"
                                                        :label="$t('Miercoles')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Thursday"
                                                        :label="$t('Jueves')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Friday"
                                                        :label="$t('Viernes')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Saturday"
                                                        :label="$t('Sabado')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Sunday"
                                                        :label="$t('Domingo')"
                                                ></v-checkbox>
                                            </v-layout>
                                        </v-container>
                                    </v-col>
                                    <v-col
                                            cols="12"
                                            md="6"
                                    >
                                        <v-menu
                                                v-model="menuCalendar"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedDateFormatted"
                                                        :label="band_invitacion_recurrente === true ? $t('fecha_inicial') : $t('fecha_inv')"
                                                        hint="DD/MM/YYYY"
                                                        persistent-hint
                                                        prepend-icon="mdi-calendar"
                                                        :error-messages="errors.dateInv"
                                                        readonly
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    v-model="date"
                                                    no-title
                                                    :min="getCurrentDate()"
                                                    :locale="$t('region')"
                                                    @input="menuCalendar = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col
                                            v-if="band_invitacion_recurrente"
                                            cols="12"
                                            md="6"
                                    >
                                        <v-menu
                                                v-model="menuCalendarExpiration"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedDateExpirationFormatted"
                                                        :label="$t('fecha_expiracion')"
                                                        hint="DD/MM/YYYY"
                                                        persistent-hint
                                                        prepend-icon="mdi-calendar"
                                                        :error-messages="errors.expiration"
                                                        readonly
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    v-model="dateExpiration"
                                                    no-title
                                                    :min="getCurrentDate()"
                                                    :locale="$t('region')"
                                                    @input="menuCalendarExpiration = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col
                                            cols="12"
                                            md="6"
                                    >
                                        <v-menu
                                                ref="menuTime"
                                                v-model="menuTime"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                :return-value.sync="time"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="time"
                                                        :label="$t('hora_inv')"
                                                        prepend-icon="mdi-clock"
                                                        :error-messages="errors.timeInv"
                                                        readonly
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                    v-if="menuTime"
                                                    v-model="time"
                                                    scrollable
                                                    format="24hr"
                                                    @click:minute="$refs.menuTime.save(time)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col
                                            cols="12"
                                            md="6"
                                    >
                                        <v-textarea
                                                v-model="subject"
                                                prepend-icon="mdi-text-subject"
                                                name="subject"
                                                :placeholder="$t('placeholder_asunto')"
                                                :label="$t('Asunto')"
                                                :error-messages="errors.subject"
                                        ></v-textarea>
                                    </v-col>
                                    <!--                                    <v-col-->
                                    <!--                                            cols="12"-->
                                    <!--                                            md="3"-->
                                    <!--                                    >-->
                                    <!--                                        <v-label>{{ $t('mensaje_vehiculo') }}</v-label>-->
                                    <!--                                        <v-radio-group-->
                                    <!--                                                v-model="vehicle"-->
                                    <!--                                                prepend-icon="mdi-car"-->
                                    <!--                                                name="vehicle"-->
                                    <!--                                                :mandatory="false"-->
                                    <!--                                                :error-messages="errors.vehicle"-->
                                    <!--                                        >-->
                                    <!--                                            <v-radio :label="$t('Si')" value=true></v-radio>-->
                                    <!--                                            <v-radio label="No" value=false></v-radio>-->
                                    <!--                                        </v-radio-group>-->
                                    <!--                                    </v-col>-->
                                    <v-col
                                            cols="12"
                                            md="6"
                                    >
                                        <v-textarea
                                                v-model="notes"
                                                prepend-icon="mdi-text"
                                                name="notes"
                                                :placeholder="$t('placeholder_notas')"
                                                :label="$t('Notas')"
                                                :error-messages="errors.notes"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-btn
                                        right
                                        :loading="loadingSend"
                                        color="primary"
                                        type="submit"
                                        @click="send()">
                                    {{$t('enviar')}}
                                <br>
                                <v-icon>mdi-send</v-icon>
                                </v-btn>
                            </v-form>
                    </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import Vue from 'vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { mapState, mapGetters } from 'vuex'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

Vue.component('vue-phone-number-input', VuePhoneNumberInput)
export default {
  name: 'invitation',
  data () {
    return {
      menuCalendar: false,
      menuCalendarExpiration: false,
      date: new Date().toISOString().substr(0, 10),
      dateExpiration: new Date().toISOString().substr(0, 10),
      time: '',
      menuTime: '',
      subject: '',
      // vehicle: null,
      notes: '',
      loadingSend: false,
      loading: false,
      errors: [],
      dialogNewContact: false,
      celular_nuevo: '',
      countries: ['MX', 'US'],
      custom_cell_phone: {},
      band_cellphone: false,
      cellphone_plus_country_code: '',
      entries: [],
      email: [],
      isLoading: false,
      search: null,
      descriptionLimit: 60,
      guests: [],
      band_invitacion_recurrente: false,
      supplier: false,
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
      days: '',
      dialogAtLeastOneDay: false,
      // Guest Data
      first_name: '',
      last_name: '',
      celular: '',
      emailGuest: '',
      // Imágenes
      dialogImageFront: false,
      dialogImageBack: false,
      dialogImageProfile: false,
      imageFrontURL: '',
      imageBackURL: '',
      imageProfileURL: '',
      resultFrontURL: '',
      resultBackURL: '',
      resultProfileURL: '',
      resultAuxFrontURL: '',
      resultAuxBackURL: '',
      resultAuxProfileURL: '',
      dialogGuest: false,
      bandGuest: false,
      errores: [],
      update: false,
      activa: '',
      fab: false,
      dialogCellNumberWrong: false,
      dialogNopay: false,
      show: false,
      degrees: 0,
      ratio: '1'
    }
  },
  created () {
    this.timeNow()
  },
  beforeUpdate () {
    this.custom_cell_phone = {
      'countrySelectorLabel': this.$t('codigo_pais'),
      'phoneNumberLabel': this.$t('celular'),
      'example': this.$t('ejemplo')
    }
  },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['getProfile']),
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedDateExpirationFormatted () {
      return this.formatDate(this.dateExpiration)
    },
    fields () {
      if (!this.email) return []

      return Object.keys(this.email).map(key => {
        return {
          key,
          value: this.email[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map(entry => {
        const email = entry.first_name.length > this.descriptionLimit
          ? entry.first_name.slice(0, this.descriptionLimit) + '...'
          : entry.first_name

        return Object.assign({}, entry, { email })
      })
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    search (val) {
      if (val !== null) {
        if (val.length > 2) {
          this.isLoading = true
          // Lazily load input items
          const config = {
            method: 'get',
            url: 'https://clubtest.intrare.app/users/filter?search=' + val,
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config)
            .then(response => {
              console.log(response.data)
              if (this.entries.length > 0) {
                for (var i = 0; i < response.data.length; i++) {
                  this.entries.push(response.data[i])
                }
              } else {
                this.entries = response.data
              }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => (this.isLoading = false))
        }
      }
    }
  },
  methods: {
    getCurrentDate () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd
      return today
    },
    timeNow () {
      var d = new Date()
      var h = (d.getHours() < 10 ? '0' : '') + d.getHours()
      var m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
      this.time = h + ':' + m
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    send () {
      console.log(this.date)
      console.log(this.time)
    },
    validateCellNumber () {
      if (this.band_cellphone === true) {
        this.dialogNewContact = false
        this.addNewContact()
      }
    },
    addNewContact () {
      this.entries.push(
        {
          'first_name': 'Usuario',
          'last_name': 'Nuevo',
          'email': null,
          'cellNumber': this.cellphone_plus_country_code
        }
      )
      this.email.push(
        {
          'first_name': 'Usuario',
          'last_name': 'Nuevo',
          'email': null,
          'cellNumber': this.cellphone_plus_country_code
        }
      )
    },
    onChange (data) {
      console.log(data.formattedNumber)
      this.cellphone_plus_country_code = data.formattedNumber
      this.band_cellphone = data.isValid
    },
    remove: function (item) {
      const index = this.email.indexOf(item.cellNumber)
      console.log(index)
      if (index >= 0) this.email.splice(index, 1)
    },
    getGuests () {
      this.guests = []
      // console.log('Entries = ', this.entries)
      // console.log('Emails = ', this.email)
      for (var j = 0; j < this.email.length; j++) {
        for (var i = 0; i < this.entries.length; i++) {
          // Compara Número de Celular
          if (this.entries[i].cellNumber === this.email[j].cellNumber && this.entries[i].email !== null) {
            console.log(this.entries[i].cellNumber, ' == ', this.email[j])
            this.guests.push(
              {
                'email': this.entries[i].email,
                'cellNumber': this.entries[i].cellNumber,
                'fullNameGuest': null
              }
            )
            break
          }
          if (this.entries[i].cellNumber === this.email[j].cellNumber && this.entries[i].email === null) {
            console.log(this.entries[i].cellNumber, ' == ', this.email[j])
            this.guests.push(
              {
                'email': null,
                'cellNumber': this.entries[i].cellNumber,
                'fullNameGuest': null
              }
            )
            break
          }
          if (this.entries[i].cellNumber === this.email[j] && this.entries[i].email !== null) {
            console.log(this.entries[i].cellNumber, ' == ', this.email[j])
            this.guests.push(
              {
                'email': this.entries[i].email,
                'cellNumber': this.entries[i].cellNumber,
                'fullNameGuest': null
              }
            )
            break
          }
          if (this.entries[i].cellNumber === this.email[j] && this.entries[i].email === null) {
            console.log(this.entries[i].cellNumber, ' == ', this.email[j])
            this.guests.push(
              {
                'email': null,
                'cellNumber': this.entries[i].cellNumber,
                'fullNameGuest': null
              }
            )
            break
          }
        }
      }
    },
    getDays () {
      this.days = ''

      if (this.Monday) {
        this.days = '0'
      }
      if (this.Tuesday) {
        this.days += '1'
      }
      if (this.Wednesday) {
        this.days += '2'
      }
      if (this.Thursday) {
        this.days += '3'
      }
      if (this.Friday) {
        this.days += '4'
      }
      if (this.Saturday) {
        this.days += '5'
      }
      if (this.Sunday) {
        this.days += '6'
      }
    },
    AtLeastOneDay () {
      var count = 0

      if (this.Monday) {
        count++
      }
      if (this.Tuesday) {
        count++
      }
      if (this.Wednesday) {
        count++
      }
      if (this.Thursday) {
        count++
      }
      if (this.Friday) {
        count++
      }
      if (this.Saturday) {
        count++
      }
      if (this.Sunday) {
        count++
      }
      return count
    },
    createInvitation () {
      if (this.band_invitacion_recurrente === true && this.AtLeastOneDay() === 0) {
        this.dialogAtLeastOneDay = true
      } else {
        var weekdays = ''
        var typeInvitation = 0

        this.loadingSend = true
        this.getGuests()
        if (this.guests.length === 0) {
          this.guests = null
        }

        if (this.band_invitacion_recurrente === true) {
          this.getDays()
          weekdays = this.days
          typeInvitation = 2
        }
        const config = {
          method: 'post',
          url: 'https://clubtest.intrare.app/invitation/create/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: {
            'guests': this.guests,
            'subject': this.subject,
            'dateInv': this.date,
            'timeInv': this.time,
            'expiration': this.dateExpiration,
            'diary': weekdays,
            'notes': this.notes,
            'typeInv': typeInvitation,
            'vehicle': true,
            'supplier': this.supplier
          }
        }
        axios(config)
          .then(ok => {
            this.loadingSend = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loadingSend = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errors = error.response.data
            }
            if (error.response.status === 401) {
              this.dialogNopay = true
              console.log('No ha pagado el Servico')
            }
          })
      }
    },
    clear () {
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
      this.cleanFields()
    },
    cleanFields () {
      this.email = []
      this.date = new Date().toISOString().substr(0, 10)
      this.timeNow()
      this.subject = ''
      this.supplier = false
      this.notes = ''
      // this.vehicle = null
      this.entries = []
    },
    createGuest () {
      if (this.band_cellphone === true) {
        this.errores = []
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        bodyFormData.set('first_name', this.first_name)
        bodyFormData.set('last_name', this.last_name)
        bodyFormData.set('cellNumber', this.celular)
        // bodyFormData.set('email', this.emailGuest.toLowerCase())
        bodyFormData.set('username', this.emailGuest.toLowerCase())
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front.jpeg')
        }
        bodyFormData.append('idFront', fileImageFront)
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back.jpeg')
        }
        bodyFormData.append('idBack', fileImageBack)
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar.jpeg')
        }
        bodyFormData.append('avatar', fileImageProfile)
        const config = {
          method: 'post',
          url: 'https://clubtest.intrare.app/user/guestCreate/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_invitado_alta'))
            this.dialogGuest = false
            setTimeout(this.cleanFieldsGuest, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    cleanFieldsGuest () {
      this.errores = []
      this.first_name = ''
      this.last_name = ''
      this.celular = ''
      this.emailGuest = ''
      this.password = ''
      this.resultFrontURL = ''
      this.resultBackURL = ''
      this.resultProfileURL = ''
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    getCutingFront () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront.clip() // call component's clip method
      this.resultFrontURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultFrontURL)
      this.dialogImageFront = false
      if (this.bandGuest === true) {
        this.dialogGuest = true
      } else {
        this.dialog = true
      }
    },
    getCutingBack () {
      const canvas = this.$refs.clipperImageBack.clip() // call component's clip method
      this.resultBackURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultBackURL)
      this.dialogImageBack = false
      if (this.bandGuest === true) {
        this.dialogGuest = true
      } else {
        this.dialog = true
      }
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultProfileURL)
      this.dialogImageProfile = false
      if (this.bandGuest === true) {
        this.dialogGuest = true
      } else {
        this.dialog = true
      }
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onInput ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      this.celular = number.e164
      this.band_cellphone = isValid
    },
    example: item => item.first_name + ' ' + item.last_name,
    customFilter (item, queryText) {
      const textOne = item.first_name.toLowerCase()
      const textTwo = item.last_name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #2a2738 #2a2738 #2a2738 #2a2738;
        border-width: 3px 3px 3px 3px;
        text-align: center;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #2a2738;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
